import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Diagram, store as diagramStore, setEntities, setConfig, diagramOn } from 'react-flow-diagram';
import isEqual from 'lodash/isEqual';

import { nodeIcons } from './nodeicons';
import { NODE_TYPE } from '../../../../../../../data/config/constants';
import { showMessage } from '../../../../../../../data/config/utils';
import EntityNode from './entitynode';
import WorkflowNode from './workflownode';

const getConfig = () => {
    let config = {
        gridSize: 20,
        entityTypes: {}
    };
    config.entityTypes[NODE_TYPE.NODE] = { width: 200, height: 200 };
    config.entityTypes[NODE_TYPE.WORKFLOW] = { width: 200, height: 200 };
    return config;
};


class FlowDiagram extends Component {
    componentDidMount() {
        diagramStore.dispatch(setConfig(getConfig()));
        diagramStore.dispatch(setEntities(this.props.model));
        diagramOn('anyChange', this.props.diagramOnChange);
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.model, this.props.model)) {
            diagramStore.dispatch(setEntities(this.props.model));
        }
    }

    getCustomEntities = () => {
        const { createEntityNode, editEntityNode, createWorkflowNode, editWorkflowNode } = this.props;
        let customEntities = {};
        customEntities[NODE_TYPE.NODE] = {
            component: (props) => <EntityNode {...props} removeNode={this.removeNode} connectLink={this.connectLink} createEntityNode={createEntityNode} editEntityNode={editEntityNode} createWorkflowNode={createWorkflowNode} />,
            icon: nodeIcons.entityNode,
        };
        customEntities[NODE_TYPE.WORKFLOW] = {
            component: (props) => <WorkflowNode {...props} removeNode={this.removeNode} editWorkflowNode={editWorkflowNode} />,
            icon: nodeIcons.workflowNode,
        };
        return customEntities;
    };

    removeNode = (payload) => {
        if (this.props.is_update_allowed) {
            diagramStore.dispatch({
                type: 'rd/entity/REMOVE',
                payload,
            });
        } else {
            showMessage('warning', 'you have not permission to delete node');
        }
    }

    connectLink = (payload) => {
        diagramStore.dispatch({
            type: 'rd/canvas/CONNECT',
            payload,
        })
    }

    render() {
        return <Diagram customEntities={this.getCustomEntities()} />;
    }
}

FlowDiagram.propTypes = {
    model: PropTypes.array,
    diagramOnChange: PropTypes.func,
    editEntityNode: PropTypes.func,
    createEntityNode: PropTypes.func,
    editWorkflowNode: PropTypes.func,
    createWorkflowNode: PropTypes.func,
    is_update_allowed: PropTypes.bool,
};

FlowDiagram.defaultProps = {
    is_update_allowed: true
};

export default FlowDiagram;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/workflowdiagram/flowdiagram/index.js